// ================================
// XSocialLogin.tsx
// ================================
import { useEffect } from 'react';

function generateRandomString(bytes = 32) {
  const array = new Uint8Array(bytes);
  window.crypto.getRandomValues(array);
  // Base64URL (بدون + / =)
  const base64 = btoa(String.fromCharCode.apply(null, Array.from(array)));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function sha256(plain: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
}

function base64urlencode(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

const XSocialLogin = () => {
  useEffect(() => {
    const clientId = 'YWhpSjUweHhUNGN4c09hSFR5ZGg6MTpjaQ';
    const redirectUri ='https://accounts.salla.com/auth/social-callback/x';

    if (!clientId) {
      // لو تحب بدّلها UI بدل console
      console.error('Missing REACT_APP_X_CLIENT_ID');
      return;
    }

    const state = generateRandomString(16);
    const codeVerifier = generateRandomString(64);

    // خزّنها عشان تتحقق منها في callback
    sessionStorage.setItem('x_oauth_state', state);
    sessionStorage.setItem('x_code_verifier', codeVerifier);

    (async () => {
      const hashed = await sha256(codeVerifier);
      const codeChallenge = base64urlencode(hashed);

      const params = new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'users.read tweet.read users.email',
        state,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        
      });

      window.location.href = `https://twitter.com/i/oauth2/authorize?${params.toString()}`;
    })();
  }, []);

  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        background: '#ffffff',
        color: '#333',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderTop: '4px solid #000000',
            borderRadius: '50%',
            width: 50,
            height: 50,
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px',
          }}
        />
        <div>Redirecting to X…</div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default XSocialLogin;
